export enum MfaState {
    Enabled = "enabled",
    Delayed = "delayed",
    Disabled = "disabled",
    NotConfigured = "not configured"
}
